/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useContext } from 'react'
import {  useParams } from 'react-router-dom'
import { Form, Row, Col } from 'react-bootstrap'
import makeAnimated from 'react-select/animated'
import Select from 'react-select'
import '../CommunityCreate.css'
import { Link } from 'react-router-dom'
import { CommunityContext } from '../CommunityContext'
import { apiUpdateCommunity } from '../../api/api'
import { Alert } from '@mui/material'

const CommunityUpdate = ({communityData}) => {
  const { isLoaded, fetchCommunityData } = useContext(CommunityContext)
  let { id } = useParams('0')
  const animatedComponents = makeAnimated()
  const [showAlert, setShowAlert] = useState(false)
  const [alertText, setAlertText] = useState('')
  const [formButtonDisabled, setformButtonDisabled] = useState(false)
  const [inputName, setInputName] = useState('')
  const [inputTags, setInputTags] = useState([])
  const [inputRules, setInputRules] = useState('')
  const [inputShortDesc, setInputShortDesc] = useState('')
  const [inputDesc, setInputDesc] = useState('')
  const [alertVariant, setAlertVariant] = useState("info")
  const [file, setFile] = useState(null)

  const handleAlert = (variant, text) => {
    setAlertVariant(variant)
    setAlertText(text)
    setShowAlert(true)
    setTimeout(() => setShowAlert(false), 5000)
  }

  const tags = [
    { value: 'Sport', label: 'Sport' },
    { value: 'Hobby', label: 'Hobby' },
    { value: 'Social', label: 'Social' },
    { value: 'Art', label: 'Art'},
    { value: 'E-Sport', label: 'E-Sport'},
    { value: 'Academic', label: 'Academic'}
  ]

  const handleRulesChange = (event) => {
    setInputRules(event.target.value)
  }

  const handleShortDescChange = (event) => {
    setInputShortDesc(event.target.value)
  }

  const handleDescChange = (event) => {
    setInputDesc(event.target.value)
  }

  const handleTagsChange = (event) => {
    setInputTags(Array.isArray(event) ? event.map(x => x.value) : [])
  }

  const handleSubmit = (event) => {
    event.preventDefault()
    setformButtonDisabled(true)
    let data = {
      "shortDescription": inputShortDesc,
      "longDescription": inputDesc,
      "status": communityData.status,
      "rules": inputRules,
      "publicMembers": [...new Set(communityData.publicMembers)],
      "pendingMembers": [...new Set(communityData.pendingMembers)],
      "totalMembers": [...new Set(communityData.publicMembers)].length + 1,
      "tags": inputTags
    }
    const formData = new FormData();
    formData.append('update_data', JSON.stringify(data));
    file && formData.append('file', file);

    apiUpdateCommunity(id, formData).then((res) => {
      fetchCommunityData(res.data._id)
      handleAlert("success", "Community updated")
      setformButtonDisabled(false)
    }).catch(error => {
      setformButtonDisabled(false)
      handleAlert("error", "Something went wrong")
      console.log(error)
    })
  }

  const loadFormData = () => {
    setInputName(communityData.name)
    setInputTags(communityData.tags)
    setInputRules(communityData.rules)
    setInputShortDesc(communityData.shortDescription)
    setInputDesc(communityData.longDescription)
  }

useEffect(() => {
  loadFormData()
}, [communityData])


return (
  <>
    {showAlert && 
      <Alert style={{marginBottom:"24px"}} severity={alertVariant} onClose={() => setShowAlert(false)}>
        {alertText}
      </Alert>
    }

    <Form onSubmit={handleSubmit}>
    <Row>
        <Col md="6" xs="12">
        <Form.Group className="mb-3">
          <Form.Label>Name</Form.Label>
          <Form.Control 
            value={inputName} 
            type="text" 
            name="name"
            data-testid="input-community-name" 
            required
            disabled
            maxLength="50"
            >
          </Form.Control>
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Tags</Form.Label>
          <Select
                name="tags"
                data-testid="input-community-tags" 
                isMulti
                className="basic-multi-select"
                classNamePrefix="select"
                closeMenuOnSelect={false}
                components={animatedComponents}
                options={tags}
                value={tags ? tags.filter(obj => inputTags.includes(obj.value)):null}
                onChange={handleTagsChange}
                required
                disabled = {!isLoaded}
            />
        </Form.Group>
        <Form.Group className="mb-3">
          <Form.Label>Rules</Form.Label>
          <Form.Control 
            data-testid="input-community-rules" 
            as="textarea" 
            value={inputRules} 
            type="text" 
            name="rules" 
            onChange={handleRulesChange} 
            maxLength="300"
            disabled = {!isLoaded}
          >
          </Form.Control>
        </Form.Group>

        <Form.Group controlId="formFileDisabled" className="mb-3" onChange={e => setFile(e.target.files[0])}>
          <Form.Label>Image</Form.Label>
          <Form.Control type="file" />
        </Form.Group>
      </Col>
      <Col md="6" xs="12">
        <Form.Group className="mb-3">
          <Form.Label>Short Description</Form.Label>
          <Form.Control 
            data-testid="input-community-shortdesc" 
            as="textarea" 
            value={inputShortDesc} 
            type="text" 
            name="shortDesc" 
            onChange={handleShortDescChange} 
            maxLength="100"
            disabled = {!isLoaded}
          >
          </Form.Control>
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Description</Form.Label>
          <Form.Control 
            data-testid="input-community-desc"  
            as="textarea" 
            value={inputDesc} 
            type="text" 
            name="longDesc" 
            onChange={handleDescChange} 
            maxLength="255"
            disabled = {!isLoaded}
          >
          </Form.Control>
        </Form.Group>
      </Col>
      <div className="form-buttons">
          <Link to={`/community/${id}/overview`} disabled={formButtonDisabled ? true: false}>
            <button className='button-secondary'>
              Cancel
            </button>
          </Link>
          <button className='button-primary' type="submit" disabled={!isLoaded? true: formButtonDisabled ? true: false}>
            Submit
          </button>
        </div>
    </Row>
  </Form>
  </>
)

}

export default CommunityUpdate